import React from "react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden pt-32 md:pt-44 pb-24 md:pb-32">
      {/* Background layers */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[#F9F8F6]" />
        <div
          className="absolute inset-0 opacity-[0.18] mix-blend-multiply"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1534171472159-edb6d1e0b63c?auto=format&fit=crop&w=1900&q=70')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div
          className="absolute -top-32 -right-40 w-[620px] h-[620px] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, rgba(140,115,93,0.22) 0%, rgba(140,115,93,0) 70%)",
          }}
        />
        <div
          className="absolute -bottom-40 -left-32 w-[540px] h-[540px] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, rgba(184,154,126,0.20) 0%, rgba(184,154,126,0) 70%)",
          }}
        />
        <div className="grain" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-end">
          <div className="lg:col-span-8 fade-up">
            <span
              data-testid="hero-overline"
              className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-[#6E5A4E]"
            >
              <span className="w-8 h-px bg-[#8C735D]" />
              Cross-Border Property Consultancy
            </span>

            <h1
              data-testid="hero-headline"
              className="font-serif-display text-[#2B211A] mt-7 text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight font-light"
            >
              Quiet stewardship<br />
              <span className="italic text-[#8C735D]">for international</span><br />
              property portfolios.
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-8 max-w-2xl text-[#6E5A4E] text-lg md:text-xl font-light leading-relaxed"
            >
              Dira Yanuar Rusdias LLC is the unbiased owner&rsquo;s representative for high-net-worth investors and absentee
              landlords worldwide. Independent advisory, spatial positioning, and remote project oversight —
              a US-based practice anchored in prime London.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 bg-[#2B211A] hover:bg-[#8C735D] text-[#F9F8F6] px-7 py-4 rounded-full text-sm font-medium font-body transition-colors duration-300"
              >
                Schedule a Consultation
                <span aria-hidden>→</span>
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 text-sm font-medium font-body text-[#2B211A] hover:text-[#8C735D] transition-colors duration-300 border-b border-[#2B211A] hover:border-[#8C735D] pb-1"
              >
                Explore the practice
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 fade-up" style={{ animationDelay: "200ms" }}>
            <div className="border-t border-[#D6CDBB] pt-8 space-y-7">
              <Stat number="01" title="Independent" body="Pure fee-for-service — zero brokerage, zero fund handling, zero conflicts." />
              <Stat number="02" title="Technical" body="Data-driven spatial blueprints engineered for premium yield and compliance." />
              <Stat number="03" title="Remote-native" body="PropTech-enabled oversight so your asset performs while you live elsewhere." />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, title, body }) {
  return (
    <div className="flex gap-5">
      <div className="font-serif-display text-3xl text-[#8C735D] leading-none w-10 shrink-0">{number}</div>
      <div>
        <div className="font-serif-display text-xl text-[#2B211A]">{title}</div>
        <p className="text-sm text-[#6E5A4E] mt-1 leading-relaxed">{body}</p>
      </div>
    </div>
  );
}
